export default {
  getGruposDeRotas: state => state.gruposDeRotas,
  getSpecificGrupoDeRotas: state => state.grupoDeRotas,
  getGrupoDeRotasUse: state => state.grupoDeRotasUse,
}